import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCarSide,
  faTags,
  faMoneyCheckAlt,
} from "@fortawesome/free-solid-svg-icons";

function ChooseUs() {
  return (
    <section className="choose-section" style={{ fontFamily: "Montserrat" }}>
      <div className="container">
        <div className="choose-container">
          <div className="text-container">
            <div className="text-container__left">
              <h4 style={{fontFamily:'Montserrat'}}>Why Choose Us</h4>
              <h2 style={{fontFamily:'Montserrat'}}>Best valued deals you will ever find</h2>
              <p style={{fontFamily:'Montserrat'}}>
              WakaForMe Ride website not only ease means of transportation in Nigeria, we also provide jobs to fellow Nigerians who are private car owners and motorbike (okada) riders. Fast, reliable and affordable transportation is our modus operandi. <br /> <br />
                Discover the best deals you'll ever find with our unbeatable
                offers. We're dedicated to providing you with the best value for
                your money, so you can enjoy top-quality services and products
                without breaking the bank. Our deals are designed to give you
                the ultimate ride experience, so don't miss out on your chance
                to save big.
              </p>
              <a
                href="https://wakaforme.com"
                style={{
                  background: "#f7931e",
                  border: "1px solid #f7931e",
                  color: "#fff",
                  padding: "10px 20px",
                  display: "inline-block",
                  textDecoration: "none",
                  borderRadius: "5px",
                }}
              >
                Find Details &nbsp;
                <i className="fa-solid fa-angle-right"></i>
              </a>
            </div>

            <div className="text-container__right">
              <div className="text-container__right__box" style={boxStyle}>
                <FontAwesomeIcon icon={faCarSide} style={iconStyle} />
                <div className="text-container__right__box__text">
                  <h4 style={{fontFamily:'Montserrat'}}>City Rides</h4>
                  <p style={{fontFamily:'Montserrat', color:'white'}}>
                    Experience the convenience and comfort of our reliable rides
                    across the city. Enjoy a stress-free journey with our
                    professional drivers and modern vehicles.
                  </p>
                </div>
              </div>

              <div className="text-container__right__box" style={boxStyle}>
                <FontAwesomeIcon icon={faTags} style={iconStyle} />
                <div className="text-container__right__box__text">
                  <h4 style={{fontFamily:'Montserrat'}}>All Inclusive Pricing</h4>
                  <p style={{fontFamily:'Montserrat', color:'white'}}>
                    Get everything you need in one convenient, transparent price
                    with our all-inclusive pricing policy.
                  </p>
                </div>
              </div>

              <div className="text-container__right__box" style={boxStyle}>
                <FontAwesomeIcon icon={faMoneyCheckAlt} style={iconStyle} />
                <div className="text-container__right__box__text">
                  <h4 style={{fontFamily:'Montserrat'}}>No Hidden Charges</h4>
                  <p style={{fontFamily:'Montserrat', color:'white'}}>
                    Enjoy peace of mind with our no hidden charges policy. We
                    believe in transparent and honest pricing.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

const boxStyle = {
  backgroundColor: "#FC8B24",
  color: "white",
  padding: "20px",
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  gap: "20px",
  marginBottom: "20px",
};

const iconStyle = {
  fontSize: "40px",
  color: "white",
};

export default ChooseUs;
